<template>
  <div class="row linha-monitoramento">

    <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
      aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
      data-backdrop="static" v-if="showModalConfirmarGravacao">
      <div class="modal-dialog modal">
        <div class="modal-content">
          <div class="modal-body"> 

            <span class="text-center" v-html="mensagemConfirmarGravacao"></span><br>
            
              <div class="success-checkmark">
                <div class="check-icon">
                  <span class="icon-line line-tip"></span>
                  <span class="icon-line line-long"></span>
                  <div class="icon-circle"></div>
                  <div class="icon-fix"></div>
                </div>
              </div>
              <br>
              <span class="text-center" v-html="mensagemConfirmarGravacaoQuantidade"></span>
          </div>
          <div class="modal-footer">
            <a href="#" class="text-danger"  v-on:click="showModalConfirmarGravacao = false"><strong>Fechar</strong></a>
          </div>
        </div>
      </div>
    </div>


    <div class="col-md-3 coluna-monitoramento-veiculos">
      <div id="listaVeiculosMonitoramento">
        <div class="row">
          <div class="col-md-12 text-center">
            <div class="card card-monitoramento">
              <div class="row">
                <div class="form-group col-md-12">
                  <div class="btn-group btn-block">
                    <button type="button" class="btn btn-danger btn-block" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Ferramentas de Cadastro
                    </button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" v-on:click="mostrarCadastroPonto()"><i class="fas fa-map-marker"></i>Cadastro de Pontos</a>
                      <!-- <a class="dropdown-item" v-on:click="mostrarCadastroArea()"><i class="fas fa-dot-circle"></i>Cadastro de Áreas</a>
                      <a class="dropdown-item" v-on:click="mostrarCadastroRota()"><i class="fas fa-map-marked"></i>Cadastro de Rotas</a> -->
                      <div class="dropdown-divider"></div>
                    </div>
                  </div>
                </div>
              </div>
              
              

              <div class="animated fadeIn" v-if="showCardPonto">
                <div class="row">
                  <h4>Pontos</h4> <span style="position: absolute; right: 8px; font-size: 20px;" v-on:click="showCardPonto = false"><i class="fas fa-times"></i></span>
                  <div class="form-group col-md-12 text-left">
                    <label>Descrição</label>
                    <input placeholder="Descrição do ponto" class="form-control" type="text" v-model="ponto.descricao"> 
                  </div>
                  <template v-if="$auth.check('P110')">
                    
                    <div class="form-group col-md-12 text-left">
                      <label>Cliente:</label><br>
                      <input type="hidden" id="pontoClienteId" v-model="ponto.clienteId" />
                      <buscar-cliente  v-validate="'required'" id="pontoClienteNome" name="pontoClienteNome" :classes="{ input: 'input pula form-control', wrapper: 'input-wrapper'}" :required="true" :errors="errors.has('clienteNome')" v-model="ponto.clienteNomeFantasia" :on-select="setarClientePonto" :on-blur="verificarClientePonto"/>
                    </div>
                  </template>
                  <template v-if="$auth.check('P110')">
                    <div class="form-group col-md-12 text-left">
                      <label>Tipo do Ponto</label>
                      <select class="pula form-control custom" v-model="ponto.pontoTipoId">
                        <option v-for="pontoTipo in pontosTipos" selected v-bind:value="pontoTipo.id">{{pontoTipo.descricao}}</option>
                      </select>
                    </div>
                  </template>

                  <div class="form-group col-md-12">
                    <button class="btn btn-success btn-block" v-on:click="gravarPonto();"><i v-if="processando" class="fa fa-spinner fa-spin"></i> Gravar Ponto</button>
                  </div>
                  <hr/>
                </div>
              </div>

              <div  class="animated fadeIn" v-if="showCardArea"> 
                <div class="row">
                  <h4>Áreas</h4> <span style="position: absolute; right: 8px; font-size: 20px;" v-on:click="showCardArea = false"><i class="fas fa-times"></i></span>
                  <div class="form-group col-md-12 text-left">

                    <label>Descrição</label>
                    <input placeholder="Descrição do area" class="form-control" type="text" v-model="area.descricao"> 

                    <label>Tamnho área <small>&nbsp;&nbsp;&nbsp;(em metros)</small></label>
                    <input placeholder="Tamano em Metros" class="form-control" type="text" v-model="area.tamanho"> 

                    <label>Tipo da área</label>
                    <select class="form-control" v-model="area.tipo">
                      <option value="0">Área geral</option>
                      <option value="1">Vinculada a veículo</option>
                    </select>
                  </div>

                  <div class="form-group col-md-12">
                    <button class="btn btn-success btn-block" v-on:click="gravarArea();">Gravar Área</button>
                  </div>
                </div>
              </div>

              <div class="animated fadeIn" v-if="showCardRota"> 
                <div class="row">
                  <h4>Rotas</h4> <span style="position: absolute; right: 8px; font-size: 20px;" v-on:click="showCardRota = false"><i class="fas fa-times"></i></span>
                  
                  <div class="form-group col-md-12">
                    <label>Origem:</label>
                    <gmap-autocomplete
                      class="form-control"
                      placeholder="Origem"
                      @place_changed="setRotaOrigem">
                    </gmap-autocomplete>

                    <label>Destino:</label>
                    <gmap-autocomplete
                      class="form-control"
                      placeholder="Origem"
                      @place_changed="setRotaDestino">
                    </gmap-autocomplete>

                    <button class="btn btn-success btn-block" v-on:click="buscarRota();">Buscar Rota</button>
                    
                    <label>Descrição</label>
                    <input placeholder="Descrição da rota" class="form-control" type="text" v-model="rota.descricao"> 
                  </div>
                  <div class="form-group col-md-12">
                    <button class="btn btn-success btn-block" v-on:click="gravarRota();">Gravar Rota</button>
                  </div>
                </div>
              
                
              </div>


            

              <div class="row">
                <div class="col-md-6">
                  <button class="btn btn-success btn-block" v-on:click="removerMarkers();removerLugares();limparSelecionados()">Limpar Mapa</button>
                </div>
                <div class="col-md-6">
                  <button class="btn btn-success btn-block" v-on:click="adicionarMarkers()">Todos Mapa</button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <select v-model="atualizarGrid" class="form-control" v-on:change="startInterval">
                    <option value="0">Não Atualizar Mapa</option>
                    <option value="300000">5 Minutos</option>
                    <option value="180000">3 Minutos</option>
                    <option value="60000">1 Minuto</option>
                  </select>
                </div>
              </div>
              <br>
              <div class="row">
                <div class="col-md-8">
                  <input id="busca" name="busca" placeholder="Filtrar veículo" class="form-control" type="text" v-model="busca" v-on:keyup.enter="limparSelecionados(),buscarGrid(),buscarGridAlertaRoubo()"> 
                </div>
                <div class="col-md-4">
                  <button class="btn btn-success btn-block" @click="limparSelecionados(),buscarGrid(),buscarGridAlertaRoubo()">Buscar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="dados-monitoramento-lista-veiculos">
          <template v-if="dadosGridAlertaRoubo.length > 0">
            <div><span style="color: #ff5454 !important;font-weight: bold; font-size: 22px; ">ALERTA DE ROUBO</span><span style="position: relative; float:right; right: 8px; font-size: 20px;" v-bind:class="{ 'plus-cross-add plus-cross-rotate': !showVeiculosAlertaRoubo, 'plus-cross-add': showVeiculosAlertaRoubo }" v-on:click="showVeiculosAlertaRoubo = !showVeiculosAlertaRoubo"><i class="fas fa-times"></i></span></div>
            
            <template v-if="showVeiculosAlertaRoubo">
              <table class="table table-responsive-sm table-hover table-outline mb-0">
                <thead class="thead-light">
                  <tr>
                    <th>Veículo</th>
                    <th style="width: 30px"></th>
                  </tr>
                </thead>
                <tbody v-for="(grid, i) in dadosGridAlertaRoubo"> 
                  <tr>
                    <td><small class="text-danger"><strong>{{grid.descricaoVeiculo}}</strong></small></td>
                    <template v-if="selecionados.includes(grid.idVeiculo)">
                      <td><span class="text-danger" style="font-size: 20px" v-tooltip="'Remover do Mapa'" v-on:click="adicionarMarker(grid, true)"><i class="fas fa-map-marker-alt"></i> </span></td>
                    </template>
                    <template v-else>
                      <td><span class="text-success" style="font-size: 20px" v-tooltip="'Adicionar no Mapa'" v-on:click="adicionarMarker(grid, true)"><i class="fas fa-map-marker-alt"></i> </span></td>
                    </template>
                  </tr>
                </tbody>
              </table>
            </template>
          </template>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>Veículo</th>
                <th style="width: 30px"></th>
              </tr>
            </thead>
            <tbody v-for="(grid, i) in dadosGrid">
              <template v-if="i === 0">
                <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                  <td colspan="10"><strong>{{grid.clienteVeiculo}}</strong></td>
                </tr>
              </template>
              <template v-if="i > 0">
                <template v-if="dadosGrid[i].clienteIdVeiculo != dadosGrid[i-1].clienteIdVeiculo">
                <tr class="group ui-selectee" style="height: 32px; background: #FFA726; color: #FFF">
                  <td colspan="10"><strong>{{grid.clienteVeiculo}}</strong></td>
                </tr>
                </template>
              </template>
              <tr :class="{ 'selecionado': selecionado(grid) }" @click="selecionarItem(grid)" v-on:dblclick="editar(grid.idVeiculo)">
                <td>
                  <small class="text-muted">{{grid.descricaoVeiculo}}</small>
                </td>
                <template v-if="selecionados.includes(grid.idVeiculo)">
                  <td><span class="text-danger" style="font-size: 20px" v-tooltip="'Remover do Mapa'" v-on:click="adicionarMarker(grid, true)"><i class="fas fa-map-marker-alt"></i> </span></td>
                </template>
                <template v-else>
                  <td><span class="text-success" style="font-size: 20px" v-tooltip="'Adicionar no Mapa'" v-on:click="adicionarMarker(grid, true)"><i class="fas fa-map-marker-alt"></i> </span></td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col-md-9 coluna-monitoramento">
      <!-- <gmap-autocomplete
        placeholder="This is a placeholder text"
        @place_changed="setPlace">
      </gmap-autocomplete> -->
      <div class="row">
        <div class="col-md-10">
          <gmap-autocomplete
            id="buscarLocal"
            class="form-control"
            placeholder="Buscar local.."
            @place_changed="setPlace">
          </gmap-autocomplete>
        </div> 
        <div class="col-md-2">
          <button class="btn btn-success btn-block" @click="usePlace">Buscar</button>
        </div>
      </div>
      
      
      <gmap-map
        :center="center"
        :zoom="4"
        ref="map"
        style="width:100%  height: calc(100vh - 58px)"
      >
        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
          <span v-html="infoContent"></span>
        </gmap-info-window>
        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :icon="{
            //path: 'M 16, 1.14, 21, 2.1, 25, 4.2, 28, 7.4, 30, 11.3, 30.6, 15.74, 25.85, 26.49, 21.02, 31.89, 15.92, 43.86, 10.92, 31.89, 5.9, 26.26, 1.4, 15.74, 2.1, 11.3, 4, 7.4, 7.1, 4.2, 11, 2.1, 16, 1.14 ',
            path: 'M 0, 0, -10, -10, -10, -35, 180, -35, 180, -10 10, -10, 0, 0',
            fillColor: 'white',
            fillOpacity: 1,
            scale: .9,
            strokeColor: 'gray',
            strokeWeight: 1,
            labelOrigin: {x: 80, y: -22}
          }"
          :label="{
            color: 'black',
            strokeColor: 'black',
            strokeWeight: 8,
            fillColor: '#FFF',
            fontSize: '12px',
            text: m.descricao,
            labelOrigin: {x: 0, y: 60}
          }"
          
          @click="toggleInfoWindow(m,index)"
        ></gmap-marker>
        <gmap-circle
          v-for="(pin, index) in areas"
          :key="index"
          :center="pin.position"
          :radius=parseInt(area.tamanho)
          :visible="true"
          :options="{fillColor:'#ffa726', fillOpacity:0.5, strokeColor:'#ba791a',strokeWeight:3}"
        ></gmap-circle>
      </gmap-map>
    </div>
  
  </div>          
</template>
<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyCNdW9zNp4aaHrlBIX8r7YnB3Axv4kvDv0"></script>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      center: { lat: -17.7455301, lng: -60.6698182 },
      markers: [],
      lugares: [],
      areas: [],
      currentPlace: null,
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      selecionada: '0',
      selecionados: [],
      atualizarGrid: 0,
      atualizarGridInterval: '',
      dadosGrid: [],
      dadosGridAlertaRoubo: [],
      dadosVeiculos: [],
      pontosTipos: [],
      processando: false,
      place: null,
      visualizarPonto: false,
      visualizarArea: false,
      visualizarRota: false,
      showCardPonto: false,
      showCardArea: false,
      showCardRota: false,
      showVeiculosAlertaRoubo: true,
      openControleMapa: false,
      showModalConfirmarGravacao: false,
      mensagemConfirmarGravacao: '',
      mensagemConfirmarGravacaoQuantidade: '',
      ponto: {
        id: '0',
        latitude: '0',
        longitude: '0',
        descricao: '',
        clienteId: '0',
        pontoTipoId: '11'
      },
      area: {
        id: '0',
        latitude: '0',
        longitude: '0',
        descricao: '',
        tamanho: '50',
        clienteId: '0'
      },
      rota: {
        directionsService: null,
        directionsDisplay: null,
        rotaOrigem: '',
        rotaDestino: '',
        clienteId: '0',
        pontos: []
      }
    }
  },
  mounted () {
    // VueGoogleMaps.loaded.then(() => {
    //   var map = new VueGoogleMaps.gmapApi.maps.Map(document.getElementById('map'))
    // })
    this.buscarGrid()
    this.buscarGridAlertaRoubo()
    this.buscarPontosTipos()
    // this.buscarVeiculos()
    // this.geolocate()
  },
  methods: {
    startInterval: function () {
      let self = this
      console.log('set interval')
      if (self.atualizarGrid === 0 || self.atualizarGrid === '0') {
        clearInterval(self.atualizarGridInterval)
      } else {
        self.atualizarGridInterval = setInterval(() => {
          self.atualizarBuscarGrid()
        }, self.atualizarGrid)
      }
    },
    selecionarItem: function (item) {
      console.log(item.id)
      this.selecionada = item.idVeiculo
    },
    selecionado: function (item) {
      return this.selecionada === item.idVeiculo
    },
    buscarGridAlertaRoubo: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/grid?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos + '&alertaRoubo=true'
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosGridAlertaRoubo = dadosCadastro.dados
        self.processando = false
      })
    },
    buscarGrid: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/grid?busca=' + self.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosGrid = dadosCadastro.dados
        self.processando = false
        self.markers = []
        // self.removerMarkers()
        // self.adicionarMarkers()
      })
    },
    buscarPontosTipos: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/pontosTipos/buscarPontosTipos?busca='
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        self.pontosTipos = response.data
      })
    },
    atualizarBuscarGrid: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/grid?busca=' + self.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosGrid = dadosCadastro.dados
        self.processando = false
        self.markers = []
        self.removerMarkers()
        self.adicionarMarkers()
      })
    },
    // :icon="{
    //         path: 'M 16, 1.14, 21, 2.1, 25, 4.2, 28, 7.4, 30, 11.3, 30.6, 15.74, 25.85, 26.49, 21.02, 31.89, 15.92, 43.86, 10.92, 31.89, 5.9, 26.26, 1.4, 15.74, 2.1, 11.3, 4, 7.4, 7.1, 4.2, 11, 2.1, 16, 1.14 ',
    //         fillColor: 'red',
    //         fillOpacity: 1,
    //         scale: .9,
    //         strokeColor: 'black',
    //         strokeWeight: 1,
    //         labelOrigin: {x: 0, y: 60}
    //       }"
    // buscarGridMapa: function () {
    //   let self = this
    //   let selecionadosBusca = ''
    //   for (let i = 0; i < self.selecionados.length; i++) {
    //     if (selecionadosBusca === '') {
    //       selecionadosBusca += self.selecionados[i]
    //     } else {
    //       selecionadosBusca += ';' + self.selecionados[i]
    //     }
    //   }
    //   self.processando = true
    //   var dadosCadastro
    //   var config = {
    //     headers: {'Authorization': 'Bearer ' + this.$store.state.token}
    //   }
    //   var url = '/api/gridMapa?veiculos=' + selecionadosBusca
    //   axios.get(url, config)
    //   .then(function (response) {
    //     console.log(response.data)
    //     dadosCadastro = response.data
    //     self.dadosGrid = dadosCadastro.dados
    //     self.processando = false
    //     self.markers = []
    //     self.removerMarkers()
    //     self.adicionarMarkers()
    //   })
    // },
    buscarVeiculos: function () {
      var self = this
      self.processando = true
      var dadosCadastro
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/listarVeiculos?busca=' + this.busca
      axios.get(url, config)
      .then(function (response) {
        console.log(response.data)
        dadosCadastro = response.data
        self.dadosVeiculos = dadosCadastro
        self.processando = false
      })
    },
    adicionarMarker (posicao) {
      let self = this
      const bounds = new window.google.maps.LatLngBounds()
      let position = {
        lat: posicao.latitude,
        lng: posicao.longitude
      }
      let marker = { position: position, descricao: posicao.descricaoVeiculo, dataHora: posicao.dataHora, ignicao: posicao.ignicao, movimento: posicao.movimento, gprs: posicao.gprs, velocidade: posicao.velocidade, pontoMaisProximo: posicao.pontoMaisProximo }
      if (posicao.latitude !== 0) {
        if (self.selecionados.includes(posicao.idVeiculo)) {
          self.selecionados.splice(self.selecionados.indexOf(posicao.idVeiculo), 1)
          for (let i = 0; i < self.markers.length; i++) {
            if (self.markers[i].descricao === marker.descricao) {
              self.markers.splice(i, 1)
            }
          }
          if (self.markers.length === 1) {
            self.areas = []
            if (self.showCardArea) {
              self.areas.push(self.markers[0])
            }
          } else {
            self.areas = []
          }
        } else {
          self.markers.push(marker)
          self.selecionados.push(posicao.idVeiculo)
          if (self.markers.length === 1) {
            self.areas = []
            if (self.showCardArea) {
              self.areas.push(marker)
            }
          } else {
            self.areas = []
          }
        }
        for (let i = 0; i < self.markers.length; i++) {
          let myLatLng = new window.google.maps.LatLng({ lat: self.markers[i].position.lat, lng: self.markers[i].position.lng })
          bounds.extend(myLatLng)
        }
        self.$refs.map.fitBounds(bounds)
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18)
        }
        // self.lugares.push(this.currentPlace)
        // self.center = marker
        self.currentPlace = null
        // self.$refs.map.fitBounds(self.markers)
      }
    },
    adicionarMarkers () {
      let self = this
      const bounds = new window.google.maps.LatLngBounds()

      if (self.selecionados.length > 0) {
        for (let i = 0; i < self.dadosGrid.length; i++) {
          if (self.dadosGrid[i].latitude !== 0) {
            let marker = {
              lat: self.dadosGrid[i].latitude,
              lng: self.dadosGrid[i].longitude
            }
            if (self.selecionados.includes(self.dadosGrid[i].idVeiculo)) {
              self.markers.push({ position: marker, descricao: self.dadosGrid[i].descricaoVeiculo, dataHora: self.dadosGrid[i].dataHora, ignicao: self.dadosGrid[i].ignicao, movimento: self.dadosGrid[i].movimento, gprs: self.dadosGrid[i].gprs, velocidade: self.dadosGrid[i].velocidade, pontoMaisProximo: self.dadosGrid[i].pontoMaisProximo })
              let myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng })
              bounds.extend(myLatLng)
            }
          }
        }
      } else {
        for (let i = 0; i < self.dadosGrid.length; i++) {
          if (self.dadosGrid[i].latitude !== 0) {
            let marker = {
              lat: self.dadosGrid[i].latitude,
              lng: self.dadosGrid[i].longitude
            }
            self.markers.push({ position: marker, descricao: self.dadosGrid[i].descricaoVeiculo, dataHora: self.dadosGrid[i].dataHora, ignicao: self.dadosGrid[i].ignicao, movimento: self.dadosGrid[i].movimento, gprs: self.dadosGrid[i].gprs, velocidade: self.dadosGrid[i].velocidade, pontoMaisProximo: self.dadosGrid[i].pontoMaisProximo })
            let myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng })
            bounds.extend(myLatLng)
            self.selecionados.push(self.dadosGrid[i].idVeiculo)
          }
        }
      }
      for (let i = 0; i < self.lugares.length; i++) {
        self.markers.push({
          position: {
            lat: self.lugares[i].position.lat,
            lng: self.lugares[i].position.lng
          },
          descricao: self.lugares[i].descricao
        })
        let myLatLng = new window.google.maps.LatLng({ lat: self.lugares[i].position.lat, lng: self.lugares[i].position.lng })
        bounds.extend(myLatLng)
      }
      self.$refs.map.fitBounds(bounds)
      if (self.$refs.map.$mapObject.zoom > 18) {
        self.$refs.map.$mapObject.setZoom(18)
      }
      // self.places.push(this.currentPlace)
      // self.center = marker
      self.currentPlace = null
      // self.$refs.map.fitBounds(self.markers)
      // })
    },
    removerMarkers () {
      let self = this
      self.markers = []
    },
    removerLugares () {
      let self = this
      self.lugares = []
    },
    limparSelecionados () {
      let self = this
      self.selecionados = []
    },
    // fitBounds() {
    //   var b = new google.maps.LatLngBounds()
    //   b.extend({
    //     lat: 33.972,
    //     lng: 35.4054
    //   })
    //   b.extend({
    //     lat: 33.7606,
    //     lng: 35.64592
    //   })
    //   this.$refs.mmm.fitBounds(b)
    //   this.$refs.map.fitBounds(bounds)
    // },
    setPlace (place) {
      this.place = place
    },
    usePlace (place) {
      let self = this
      const bounds = new window.google.maps.LatLngBounds()
      if (this.place) {
        this.lugares.push({
          position: {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng()
          },
          descricao: this.place.name
        })
        this.markers.push({
          position: {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng()
          },
          descricao: this.place.name
        })
        // for (let i = 0; i < self.markers.length; i++) {
        //   let myLatLng = new window.google.maps.LatLng({ lat: self.markers[i].position.lat, lng: self.markers[i].position.lng })
        //   bounds.extend(myLatLng)
        // }
        let myLatLng = new window.google.maps.LatLng({ lat: this.place.geometry.location.lat(), lng: this.place.geometry.location.lng() })
        bounds.extend(myLatLng)
        self.$refs.map.fitBounds(bounds)
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18)
        }
        $(this.$el).find('#buscarLocal').val('')
        this.place = null
      }
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition(position => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          infoText: 'Marker 1'
        }
      })
    },
    toggleInfoWindow: function (marker, idx) {
      this.infoWindowPos = marker.position
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + parseFloat(marker.velocidade).toFixed(2) + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>'
      // check if its the same marker that was selected if yes toggle
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen
      } else {
        this.infoWinOpen = true
        this.currentMidx = idx
      }
    },
    //
    setRotaOrigem (place) {
      console.log(place)
      this.rota.rotaOrigem = place.formatted_address
    },
    setRotaDestino (place) {
      this.rota.rotaDestino = place.formatted_address
    },
    buscarRota: function () {
      let self = this
      if (self.rota.directionsDisplay === null) {
        self.rota.directionsService = new window.google.maps.DirectionsService()
        self.rota.directionsDisplay = new window.google.maps.DirectionsRenderer()
      } else {
        self.rota.directionsDisplay.setMap(null)
      }
      self.rota.directionsDisplay.setMap(self.$refs.map.$mapObject)
      var vm = this
      vm.rota.directionsService.route({
        origin: self.rota.rotaOrigem,
        destination: self.rota.rotaDestino,
        travelMode: 'DRIVING',
        provideRouteAlternatives: true
      }, function (response, status) {
        if (status === 'OK') {
          vm.rota.directionsDisplay.setDirections(response) // draws the polygon to the map
          console.log(response)
        } else {
          if (status === 'ZERO_RESULTS') {
            self.$toastr('error', 'NÃO FOI POSSÍVEL ENCONTRAR UMA ROTAS.', 'Atenção')
          }
          console.log('Directions request failed due to ' + status)
        }
      })
    },
    mostrarCadastroPonto () {
      let self = this
      self.showCardPonto = true
      self.showCardArea = false
      self.showCardRota = false
    },
    mostrarCadastroArea () {
      let self = this
      self.showCardArea = true
      self.showCardPonto = false
      self.showCardRota = false
      if (self.markers.length === 1) {
        self.areas = self.markers
      } else {
        self.areas = []
      }
    },
    mostrarCadastroRota () {
      let self = this
      self.showCardRota = true
      self.showCardPonto = false
      self.showCardArea = false
    },
    setarClientePonto: function (cliente) {
      this.ponto.clienteId = cliente.id
      this.ponto.clienteNomeFantasia = cliente.nomeFantasia
      $(this.$el).find('#pontoClienteNome').val(cliente.nomeFantasia)
    },
    verificarClientePonto: function () {
      if ($(this.$el).find('#pontoClienteId').val() === '0') {
        this.ponto.clienteId = 0
        this.ponto.clienteNome = ''
        $(this.$el).find('#pontoClienteId').val(0)
        $(this.$el).find('#pontoClienteNome').val('')
      }
      if ($(this.$el).find('#pontoClienteNomePonto').val() === '') {
        this.ponto.clienteId = 0
        this.ponto.clienteNome = ''
        $(this.$el).find('#pontoClienteId').val(0)
        $(this.$el).find('#pontoClienteNome').val('')
      }
    },
    gravarPonto () {
      let self = this
      if (self.markers.length === 0) {
        this.$toastr('error', 'Adicione um ponto de referência ao mapa.', 'Atenção')
        return
      }
      if (self.markers.length > 1) {
        this.$toastr('error', 'Adicione APENAS UM ponto de referência ao mapa.', 'Atenção')
        return
      }
      if (self.ponto.descricao === '') {
        this.$toastr('error', 'Adicione a descrição do ponto.', 'Atenção')
        return
      }
      self.ponto.latitude = self.markers[0].position.lat
      self.ponto.longitude = self.markers[0].position.lng
      self.processando = true
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      let url = '/api/pontos/salvar'
      axios.post(url, JSON.stringify(self.ponto), config)
      .then(function (response) {
        console.log(response)
        if (response.data === 'OK') {
          self.processando = false
          self.mensagemConfirmarGravacao = '<h2>Parabéns<h2><h4>Ponto gravado com sucesso!</h4><br/>'
          self.mensagemConfirmarGravacaoQuantidade = '<p>Restam <strong>0</strong> pontos para cadastro</p>'
          self.showModalConfirmarGravacao = true
          self.showCardPonto = false
          self.showCardArea = false
          self.showCardRota = false
          self.ponto = {id: '0', latitude: '0', longitude: '0', descricao: '', clienteId: '0', pontoTipoId: '0'}
        }
      })
      .catch(function (error) {
        self.processando = false
        console.log(error)
      })
    },
    gravarArea () {
      var self = this
      if (self.markers.length > 0) {
        // Add circle overlay and bind to marker
        // var circle = new window.google.maps.Circle({
        //   map: self.$refs.map,
        //   radius: 16093,    // 10 miles in metres
        //   fillColor: '#AA0000'
        // })
        // circle.bindTo('center', self.markers[0], 'position')
      }
      // let myLatLng = new window.google.maps.LatLng({ lat: self.lugares[i].position.lat, lng: self.lugares[i].position.lng })
      // bounds.extend(myLatLng)
      // }
      // self.$refs.map.fitBounds(bounds)
      // if (self.$refs.map.$mapObject.zoom > 18) {
      //   self.$refs.map.$mapObject.setZoom(18)
      // }
      // const bounds = new window.google.maps.LatLngBounds()
      // self.mensagemConfirmarGravacao = '<h2>Parabéns<h2><h4>Área gravada com sucesso!</h4><br/>'
      // self.mensagemConfirmarGravacaoQuantidade = '<p>Restam <strong>0</strong> áreas para cadastro</p>'
      // self.showModalConfirmarGravacao = true
      // self.showCardPonto = false
      // self.showCardArea = false
      // self.showCardRota = false
      // self.area = {id: '0', latitude: '0', longitude: '0', descricao: '', clienteId: '0'}
    },
    gravarRota () {
      var self = this
      self.mensagemConfirmarGravacao = '<h2>Parabéns<h2><h4>Rota gravada com sucesso!</h4><br/>'
      self.mensagemConfirmarGravacaoQuantidade = '<p>Restam <strong>0</strong> rotas para cadastro</p>'
      self.showModalConfirmarGravacao = true
      self.showCardPonto = false
      self.showCardArea = false
      self.showCardRota = false
      self.rota = {directionsService: null, directionsDisplay: null, rotaOrigem: '', rotaDestino: '', clienteId: '0', pontos: []}
    }
  }
}
</script>
<style type="text/css">
  .vue-map-container {
    min-height: calc(100vh - 98px);
    margin-top: 4px;

  }
  .labels {
    color: white;
    background-color: red;
    font-family: "Lucida Grande", "Arial", sans-serif;
    font-size: 10px;
    text-align: center;
    width: 30px;
    white-space: nowrap;
  }

  .success-checkmark {
    width: 80px;
    height: 115px;
    margin: 0 auto;
  }
  .success-checkmark .check-icon {
        width: 80px;
        height: 80px;
        position: relative;
        border-radius: 50%;
        box-sizing: content-box;
        border: 4px solid #4CAF50;
  }
  .success-checkmark .check-icon::before {
      top: 3px;
      left: -2px;
      width: 30px;
      transform-origin: 100% 50%;
      border-radius: 100px 0 0 100px;
  }
        
  .success-checkmark .check-icon::after {
      top: 0;
      left: 30px;
      width: 60px;
      transform-origin: 0 50%;
      border-radius: 0 100px 100px 0;
      animation: rotate-circle 4.25s ease-in;
  }
  
  .success-checkmark .check-icon::before, .success-checkmark .check-icon::after {
      content: '';
      height: 100px;
      position: absolute;
      background: #FFFFFF;
      transform: rotate(-45deg);
  }
        
  .icon-line {
      height: 5px;
      background-color: #4CAF50;
      display: block;
      border-radius: 2px;
      position: absolute;
      z-index: 10;
  }
  .icon-line.line-tip {
      top: 46px;
      left: 14px;
      width: 25px;
      transform: rotate(45deg);
      animation: icon-line-tip 0.75s;
  }
  
  .icon-line.line-long {
      top: 38px;
      right: 8px;
      width: 47px;
      transform: rotate(-45deg);
      animation: icon-line-long 0.75s;
  }
  .icon-circle {
      top: -4px;
      left: -4px;
      z-index: 10;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      position: absolute;
      box-sizing: content-box;
      border: 4px solid rgba(76, 175, 80, .5);
  }
  .icon-fix {
      top: 8px;
      width: 5px;
      left: 26px;
      z-index: 1;
      height: 85px;
      position: absolute;
      transform: rotate(-45deg);
      background-color: #FFFFFF;
  }

  @keyframes rotate-circle {
    0% {
        transform: rotate(-45deg);
    }
    5% {
        transform: rotate(-45deg);
    }
    12% {
        transform: rotate(-405deg);
    }
    100% {
        transform: rotate(-405deg);
    }
  }

  @keyframes icon-line-tip {
    0% {
        width: 0;
        left: 1px;
        top: 19px;
    }
    54% {
        width: 0;
        left: 1px;
        top: 19px;
    }
    70% {
        width: 50px;
        left: -8px;
        top: 37px;
    }
    84% {
        width: 17px;
        left: 21px;
        top: 48px;
    }
    100% {
        width: 25px;
        left: 14px;
        top: 45px;
    }
  }

  @keyframes icon-line-long {
    0% {
        width: 0;
        right: 46px;
        top: 54px;
    }
    65% {
        width: 0;
        right: 46px;
        top: 54px;
    }
    84% {
        width: 55px;
        right: 0px;
        top: 35px;
    }
    100% {
        width: 47px;
        right: 8px;
        top: 38px;
    }
  }
 </style>


// WEBPACK FOOTER //
// src/components/views/Monitoramento.vue